"use client";

import { Notification } from "@/types/notification";
import NotificationItem, {
  NotificationAvatar,
  NotificationWorkspaceLink,
} from "@/components/tailwind/notification/notificationItem";
import { useWorkspaceContext } from "@/contexts/workspaceContext";

interface NotificationWorkAreaAccessGrantedProps {
  notification: Notification;
}

export default function NotificationWorkAreaAccessGranted({ notification }: NotificationWorkAreaAccessGrantedProps) {
  const { getMemberName } = useWorkspaceContext();
  const displayName = getMemberName(notification.createdBy?.userId) || getMemberName(notification.createdBy?.userEmail) || notification.createdBy?.userName || "An admin";
  const workAreaName = notification.context?.workAreaName;

  return (
    <NotificationItem
      icon={<NotificationAvatar name={displayName} userId={notification.createdBy?.userId} email={notification.createdBy?.userEmail} />}
      createdAt={notification.createdAt}
      unread={!notification.read}
      title={displayName}
      message={
        <>
          Granted you access to{" "}
          <span className="font-medium text-gray-700 dark:text-gray-300">
            {workAreaName || "a workarea"}
          </span>{" "}
          in{" "}
          <NotificationWorkspaceLink
            workspaceId={notification.workspaceId}
            workspaceName={notification.workspaceName}
          />
        </>
      }
    />
  );
}
